import React from "react";

/**
 * Number input with a % suffix label (appears on the left in RTL).
 * All standard input props are forwarded.
 * Props:
 *   suffix   string  — the suffix label (default "%")
 *   ...rest         — all other props forwarded to <input>
 */
export default function InputWithSuffix({ suffix = "%", ...rest }) {
  return (
    <div className="input-with-suffix">
      <input className="input" type="text" {...rest} />
      <span className="input-suffix">{suffix}</span>
    </div>
  );
}
